import axios from "axios";
import React, { useState } from "react";
import { toast } from "sonner";
import { Button } from "src/components/ui/button";
import { BaseUrlApi, ErrorMessage } from "src/lib/api";
import { Select } from "antd";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "src/components/ui/sheet";
import { Input } from "src/components/ui/input";

export const SalaryAddSheet = ({ handleFetchSalary, users, loadingUsers }) => {
  const [showAddSheet, setShowAddSheet] = useState(false);
  const [addRecord, setAddRecord] = useState({
    user_id: null,
    value: 0,
    total_deduction: 0,
    total_bonus: 0,
    payed: false,
    payed_by: "",
  });
  const [loadinAdd, setLoadinAdd] = useState(false);

  const [errors, setErrors] = useState({});
  const handleAdd = async (e) => {
    e.preventDefault();
    setLoadinAdd(true);
    setErrors({});

    try {
      await axios.post(`${BaseUrlApi}/salaries`, addRecord);
      toast("تمت الإضافة", {
        description: "تم إضافة المرتب الجديد بنجاح 🎉",
      });

      await handleFetchSalary();
      setShowAddSheet(false);
    } catch (error) {
      const result = ErrorMessage(error);
      if (typeof result !== "object")
        toast("Error", {
          description: result,
        });
      setErrors(result);
    } finally {
      setLoadinAdd(false);
    }
  };

  return (
    <Sheet open={showAddSheet} onOpenChange={setShowAddSheet}>
      <SheetTrigger asChild>
        <Button disabled={loadingUsers}>إضافة راتب</Button>
      </SheetTrigger>
      <SheetContent side="left" dir="rtl" className="overflow-auto">
        <SheetHeader className="text-start">
          <SheetTitle>إضافة راتب جديد</SheetTitle>
        </SheetHeader>
        <div className="space-y-4 mt-3">
          <div className="flex-1">
            <label className="block font-medium mb-1">اختر عضو</label>
            <Select
              placeholder="اختر عضو"
              value={addRecord.user_id}
              onChange={(e) => setAddRecord({ ...addRecord, user_id: e })}
              style={{ width: "100%" }}
              options={users.map((user) => ({
                value: user.id,
                label: user.name,
              }))}
              // These are the key properties to fix touchability in Sheet
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              dropdownStyle={{ zIndex: 9999 }}
              virtual={false}
            />
          </div>

          {/* Salary Fields */}
          <div className="space-y-2">
            <label className="block font-medium">الراتب</label>
            <Input
              type="number"
              className="w-full p-2 border rounded mt-1"
              placeholder="أدخل الراتب"
              value={addRecord.value || ""}
              onChange={(e) =>
                setAddRecord({ ...addRecord, value: +e.target.value })
              }
            />
            {errors?.salary && (
              <p className="text-red-500 font-semibold text-sm">
                {errors.salary[0]}
              </p>
            )}
          </div>

          <div className="space-y-2">
            <label className="block font-medium">الخصومات</label>
            <Input
              type="number"
              className="w-full p-2 border rounded mt-1"
              placeholder="أدخل الإجمالي الخصم"
              value={addRecord.total_deduction || ""}
              onChange={(e) =>
                setAddRecord({ ...addRecord, total_deduction: +e.target.value })
              }
            />
            {errors?.total_deduction && (
              <p className="text-red-500 font-semibold text-sm">
                {errors.total_deduction[0]}
              </p>
            )}
          </div>

          <div className="space-y-2">
            <label className="block font-medium">المكافآت</label>
            <Input
              type="number"
              className="w-full p-2 border rounded mt-1"
              placeholder="أدخل إجمالي المكافآت"
              value={addRecord.total_bonus || ""}
              onChange={(e) =>
                setAddRecord({ ...addRecord, total_bonus: +e.target.value })
              }
            />
            {errors?.total_bonus && (
              <p className="text-red-500 font-semibold text-sm">
                {errors.total_bonus[0]}
              </p>
            )}
          </div>

          {/* <div className="space-y-2">
            <label className="block font-medium">الدفع</label>
            <Input
              type="text"
              className="w-full p-2 border rounded mt-1"
              placeholder="أدخل حالة الدفع أو التاريخ"
              value={addRecord.payed || ""}
              onChange={(e) =>
                setAddRecord({ ...addRecord, payed: e.target.value })
              }
            />
            {errors?.payed && (
              <p className="text-red-500 font-semibold text-sm">
                {errors.payed[0]}
              </p>
            )}
          </div>

          <div className="space-y-2">
            <label className="block font-medium">دفع بواسطة</label>
            <Input
              type="text"
              className="w-full p-2 border rounded mt-1"
              placeholder="أدخل اسم الجهة الدافعة"
              value={addRecord.payed_by || ""}
              onChange={(e) =>
                setAddRecord({ ...addRecord, payed_by: e.target.value })
              }
            />
            {errors?.payed_by && (
              <p className="text-red-500 font-semibold text-sm">
                {errors.payed_by[0]}
              </p>
            )}
          </div> */}

          <div className=" text-end">
            <Button onClick={handleAdd} disabled={loadinAdd}>
              {loadinAdd ? "جاري الإضافة..." : "إضافة"}
            </Button>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};
